export const ORDER_STATUS_OPTIONS = [
  { value: 'new', label: 'Нова', color: 'info' },
  { value: 'processing', label: 'В обработка', color: 'warning' },
  { value: 'in_production', label: 'Шие се', color: 'secondary' },
  { value: 'awaiting_payment', label: 'Изпратена', color: 'warning' },
  { value: 'completed', label: 'Завършена', color: 'success' },
  { value: 'returned', label: 'Върната', color: 'error' }
];

export const normalizeOrderStatus = (value) =>
  ORDER_STATUS_OPTIONS.some((option) => option.value === value) ? value : 'new';

export const getOrderStatus = (value) =>
  ORDER_STATUS_OPTIONS.find((option) => option.value === normalizeOrderStatus(value));

export const isBankPayment = (value) =>
  /(?:банков\s+(?:превод|трансфер)|bank\s+(?:transfer|wire))/iu.test(String(value || ''));
